import * as THREE from "three";
import * as ZapparThree from "@zappar/zappar-threejs";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";

let mixer : any;
let clock = new THREE.Clock();
let idleAction : THREE.AnimationAction;
let danceLoopAction : THREE.AnimationAction;
let laughAction : THREE.AnimationAction;
let roarAction: THREE.AnimationAction;

let faceTrackerGroup : ZapparThree.FaceAnchorGroup;
let faceTrackerForSmallerFace : THREE.Group;

let userSuit : any;
let currentAction : THREE.AnimationAction;

const userSuitModelSrc = new URL("../assets/models/Elmo_User_Dino_Stomp.glb", import.meta.url).href;

export function initUserSuit(FaceTrackerForSmallerFace : THREE.Group, FaceTrackerGroup : ZapparThree.FaceAnchorGroup){
	faceTrackerGroup = FaceTrackerGroup;
	faceTrackerForSmallerFace = FaceTrackerForSmallerFace
	//userSuit
	new GLTFLoader().load(userSuitModelSrc,function (gltf) {
		userSuit = gltf.scene;
		// userSuit.scale.set(8,8,8)
		// userSuit.position.set(-0.01,-2.1,-0.13)
		userSuit.scale.set(6.3,6.3,6.3)
		userSuit.position.set(-0.01,-1.68,0.02)
		faceTrackerForSmallerFace.add(userSuit);

		userSuit.traverse( function( node :any ) {
            if ( node.isMesh ) {
                node.recieveShadow = true;
                node.castShadow = true;
            }
        } );

		const animations = gltf.animations;
		mixer = new THREE.AnimationMixer( userSuit );
		mixer.timeScale = 1;
		idleAction = mixer.clipAction( animations[ 0 ] );
		danceLoopAction = mixer.clipAction( animations[ 2 ] );
		laughAction = mixer.clipAction( animations[ 5 ] );
		roarAction = mixer.clipAction( animations[ 4 ] );
		resetDanceLoop()

		mixer.addEventListener( 'loop', onLoopFinished );
		function onLoopFinished( event :any) {
			//console.log('loop finshed: dance',danceLoopAction.getEffectiveWeight(),', roar: ', roarAction.getEffectiveWeight(),', laugh: ', laughAction.getEffectiveWeight())
			if ( danceLoopAction.getEffectiveWeight() === 0 ) {
				executeCrossFade(currentAction,danceLoopAction,0.5)
			}
		}
	},
	undefined,
	function (error) {
		console.log("An error happened");
	}
	);
}

export function animationUserSuitUpdates(){
    let delta = clock.getDelta();
	if (mixer) mixer.update(delta);
}

export function playUserSuitAction(nextAnim :string){
	if(nextAnim =='laughAction'){
		executeCrossFade(currentAction,laughAction,0.5,)
	}
	else if(nextAnim =='roarAction'){
		executeCrossFade(currentAction,roarAction,0.5)
	}
  }

function setWeight( action : THREE.AnimationAction, weight : any) {
	action.enabled = true;
	action.setEffectiveTimeScale( 1 );
	action.setEffectiveWeight( weight );
}

function executeCrossFade( startAction : any, endAction : any, duration : any) {
	// Not only the start action, but also the end action must get a weight of 1 before fading
	// (concerning the start action this is already guaranteed in this place)
	currentAction = endAction;
	if ( endAction ) {
		setWeight( endAction, 1 );
		endAction.time = 0;
		if ( startAction ) {
			// Crossfade with warping
			startAction.crossFadeTo( endAction, duration, true );
		} else {
			// Fade in
			endAction.fadeIn( duration );
		}
	} else {
		// Fade out
		startAction.fadeOut( duration );
	}
}

export function stopAllAnimations(){
	laughAction.stop()
	roarAction.stop();
	idleAction.stop();
	danceLoopAction.stop();
}


export function userSuitSwitchToFaceFilter(){
	//userSuit animations
	stopAllAnimations();
	idleAction.play();

	faceTrackerGroup.add(userSuit);
	userSuit.scale.set(17.5,17.5,17.5)
	userSuit.position.set(-0.01,-4.8,-0.4)
}

export function userSuitSwitchToDanceFilter(){
	//userSuit animations
	resetDanceLoop();

	faceTrackerForSmallerFace.add(userSuit);
	userSuit.scale.set(6.3,6.3,6.3)
	userSuit.position.set(-0.01,-1.68,0.02)
}

export function resetDanceLoop(){
	stopAllAnimations();
	currentAction = danceLoopAction;
	laughAction.play();
	roarAction.play();
	danceLoopAction.play();

	setWeight(danceLoopAction, 1)
	setWeight(laughAction, 0)
	setWeight(roarAction, 0)
}
